import React, { Component } from 'react'
import styled from 'styled-components'
import { theme, breakpoints } from '../ui-config'

const StyledButton = styled.div`
    transition: box-shadow 100ms linear;
    border-radius: 6px;
    padding: 6px 23px;
    box-sizing: border-box;
    text-transform: uppercase;
    text-align: center;

    @media print {
        display: none;
    }
    &:hover {
        box-shadow: 2px 6px 16px rgba(0,0,0,0.35);
        // color: ${theme.inverseText} !important;
        // background-color: ${props => props.style.color ? props.style.color : theme.action};
    }
    
    @media (max-width: ${breakpoints.small}px) {
        padding: 6px 5px;
    }
`

export default class Button extends Component {
    render() {
        return (
            <StyledButton style={this.props.style} onClick={this.props.onClick}>
                { this.props.children }
            </StyledButton>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Button.js